/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import "./Unknown.scss";

function Uknown() {
  const [isMobileProductListOpen, setIsMobileProductListOpen] = React.useState(
    false
  );

  const handleCloseNavbar = () => {
    setIsMobileProductListOpen(false);
  };

  return (
    <div className="subPage">
      <NavBar
        isMobileProductListOpen={isMobileProductListOpen}
        onClose={handleCloseNavbar}
      />
      <div className="uknown">
        <b>Nieznany adres</b>
      </div>
      <Footer />
    </div>
  );
}

export default Uknown;
